import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Grid,
  makeStyles,
  createStyles,
  Theme,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,Dialog, DialogTitle, DialogContent, DialogActions,Typography
} from "@material-ui/core";
import useCommonApi from "../../api/useCommonApi";
import { useSnackbar } from "notistack";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import LoadingDialog from "../controls/LoadingDialog";
import DatePicker from "rsuite/DatePicker";
import { ICliente } from "../../entities/catalogos/ICliente";
import { IUsuario } from '../../entities/catalogos/IUsuario';
import { IHelp } from '../help/Help';
import { Sucursal } from '../../entities/catalogos/Sucursal';
import { IResultApi } from '../../interfaces/IResultApi';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { b64toBlob, currencyFormat } from "../../blocks/utility";
import Checkbox from "@material-ui/core/Checkbox";
import {
  Search,
  CloudUpload,
  DoneAll,
  CloudDownload,
  TableChart,
  Print  
} from "@material-ui/icons";
import { size } from "lodash";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonGreen: {
      backgroundColor: "#00653b",
      color: "#fff",
      marginLeft: theme.spacing(2),
      "&:disabled": { opacity: 0.6 },
    },
    topBar: {
       display: "flex",
  "& > *:not(:last-child)": {
    marginRight: "10px",
  },
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: theme.spacing(4),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    filterField: {
      marginRight: theme.spacing(2),
      minWidth: 180,
      backgroundColor: "#fff",
    },
    dateField: {
      marginRight: theme.spacing(2),
      minWidth: 180,
      backgroundColor: "#fff",
      height: 40,
    },
    tableWrap: {
      marginTop: theme.spacing(2),
    },        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            paddingTop: "50px",

        },
        tr: {
            fontWeight: 600,
            textAlign: "center"
        },
        filters: {
            backgroundColor: "#ececec",
            boxShadow: "none",
            verticalAlign: "middle",
            paddingTop: "10px"
        },
        label: {
            fontSize: '12px',
            fontWeight: 600,
            marginTop: "10px"
        },
        textField: {
            marginRight: theme.spacing(1),
            width: 180,
            backgroundColor: "#fff"
        },
        datePicker: {
            marginRight: theme.spacing(1),
            width: 180,
            height: 40,
            color: "#000",
            
        },
        icon: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",

        },
        marginButton: {
            margin: "10px 0px 0 30px"
        },
        cellContent: {
            minWidth: "150px"
        },
        sectionTitle: {
            width: "100%",
            textAlign: "center",
            fontSize: "25px",
            fontWeight: 600,
            paddingLeft: "200px"
        }
  })
);

// ==== Tipos de la API (response real) + mapeadores ====
type ApiRow = {
  id: number;
  integracionUUID: string;
  nombreRemitente: string;
  codigoPostalRemitente: string;
  calleRemitente: string;
  noExteriorRemitente: string;
  coloniaRemitente: string;
  tipoPersonaRemitente: string;
  rfcDistribuidorOrigen: string;
  contactoRemitente: string;
  telefonoPersonaRemitente: string;
  fechaRecoleccion: string; // p.e. "10/11/2025"
  nombreDestinatario: string;
  codigoPostalDestinatario: string;
  calleDestinatario: string;
  noExteriorDestinatario: string;
  coloniaDestinatario: string;
  tipoPersonaDestinatario: string;
  rfcDistribuidorDestinatario: string;
  contactoDestinatario: string;
  telefonoDestinatario: string;
  descripcionMercancia: string;
  observaciones: string | null;
  detalleReferencias: string;
  detalleMercancia: string;
  fechaIntegracion: string;
  estatus: string; // "1" | "3" | "4" | ...
  solicitudServicioMensaje: string | null;
  solicitudServicioId: number | null;
  numeroGuia: string | null;
  solicitudServicioFecha: string | null;
  estatusNombre:string|null;
   impresionDocumento:string|null;
  impresionEtiqueta:string|null;
};

type ApiResponse = {
  response: ApiRow[];
  success: boolean;
  code: number;
  message: string;
};
// === Tipos de respuesta del backend (validaciones) ===
type BackendValidationError = {
  fila: number;
  columna: string;
  mensaje: string;
};

type ProcessApiResponse = {
  response: {
    integracionId: string | null;
    registrosProcesados: ProcesadoRow[] | null;
    errores: BackendValidationError[] | null;
  };
  success: boolean;
  code: number;
  message: string;
};
// 1) Tipo para las filas del grid de Carga Masiva
type LayoutCargaMasivaRow = {

  Estatus: string; // "EN PROCESO" | "GENERADA" | "DENEGADA"
  SolicitudServicioMensaje: string;
  SolicitudServicioId:number;
  EstatusNombre: string;
  NombreRemitente: string;
  CodigoPostalRemitente: string;
  CalleRemitente: string;
  NoExteriorRemitente: string;
  ColoniaRemitente: string;
  TipoPersonaRemitente: string;
  RfcDistribuidorOrigen: string;
  TelefonoPersonaRemitente: string;
  FechaRecoleccion: string; // "YYYY-MM-DD" o ISO
  NombreDestinatario: string;
  CodigoPostalDestinatario: string;
  CalleDestinatario: string;
  NoExteriorDestinatario: string;
  ColoniaDestinatario: string;
  TipoPersonaDestinatario: string;
  RfcDistribuidorDestinatario: string;
  ContactoDestinatario: string;
  TelefonoDestinatario: string;
  DescripcionMercancia: string;
  Observaciones: string;
  DetalleReferencias: string;
  DetalleMercancia: string;
  NumeroGuia: string;
   ImpresionEtiqueta: string;
  ImpresionDocumento: string;
};
// === Tipos para el grid de Procesados (respuesta de handleProcesar) ===
type ProcesadoRow = {
  nombreRemitente: string;
  codigoPostalRemitente: string;
  calleRemitente: string;
  noExteriorRemitente: string;
  coloniaRemitente: string;
  tipoPersonaRemitente: string;
  rfcDistribuidorOrigen: string;
  contactoRemitente: string;
  telefonoPersonaRemitente: string;
  fechaRecoleccion: string; // dd/MM/yyyy
  nombreDestinatario: string;
  codigoPostalDestinatario: string;
  calleDestinatario: string;
  noExteriorDestinatario: string;
  coloniaDestinatario: string;
  tipoPersonaDestinatario: string;
  rfcDistribuidorDestinatario: string;
  contactoDestinatario: string;
  telefonoDestinatario: string;
  claveTipoServicio: string;
  descripcionMercancia: string;
   observaciones: string | null;
  detalleReferencias: string;
  detalleMercancia: string;
  estatus: number; // 1=Integrada, 4=Error (ejemplos)
  estatusNombre: string; // "Integrada" | "Error" ...
  solicitudServicioMensaje: string | null;
};

interface RegistroProcesado {
  id: number;
  fecha: string; // ISO
  remitente: string;
  sucursalOrigen: string;
  sucursalDestino: string;
  totalPiezas: number;
}
type Props = {
  cliente: ICliente;
  usuario: IUsuario;
  ayuda: IHelp;
};

// Si de momento no usas alguno, puedes prefix _ para evitar "unused variable"
const CargaMasivaLista: React.FC<Props> = ({ cliente, usuario, ayuda }) => {
  const classes = useStyles();
  const apiSource = useCommonApi();
  const { enqueueSnackbar } = useSnackbar();

  // Botonera / carga de archivos
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [fileOk, setFileOk] = useState(false);
  const [showLoading, setLoading] = useState(false);

  // Filtros
  const [fecha, setFecha] = useState<Date | null>(null);
  const [estatus, setEstatus] = useState<number | "">("");
  const [remitente, setRemitente] = useState("");
  const [sucursalOrigen, setSucursalOrigen] = useState<number | "">("");
  const [sucursalDestino, setSucursalDestino] = useState<number | "">("");
  const [impresionDocumento, setImpresionDocumento] = useState<number | "">("");
  const [impresionEtiquetas, setImpresionEtiquetas] = useState<number | "">("");

  // Catálogos
  const [sucursales, setSucursales] = useState<{ id: number; nombre: string }[]>([]);

  // Grid
  //const [rows, setRows] = useState<RegistroProcesado[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Índices globales seleccionados (no dependemos de ids aún)
  const [selected, setSelected] = useState<number[]>([]);
 
  // ======= Helpers =======
  const isValidExtension = (name: string) =>
    /\.xlsx?$/i.test(name) || /\.csv$/i.test(name);

  const filtrosDTO = useMemo(
    () => ({
      fecha: fecha ? new Date(fecha).toISOString().slice(0, 10) : null, // yyyy-MM-dd
      estatus: estatus || null,
      remitente: remitente.trim() || null,
      sucursalOrigenId: sucursalOrigen || null,
      sucursalDestinoId: sucursalDestino || null,
      impresionDocumento: impresionDocumento || null,
      impresionEtiquetas: impresionEtiquetas || null,
    }),
    [fecha, estatus, remitente, sucursalOrigen, sucursalDestino, impresionDocumento, impresionEtiquetas]
  );
  
// estado del grid sin datos iniciales
const [rows, setRows] = useState<LayoutCargaMasivaRow[]>([]);

const mapEstatus = (codigo?: string): string => {
  if (codigo === "1") return "INTEGRADA";
  if (codigo === "2") return "PROCESANDO";
  if (codigo === "3") return "Generada";
  if (codigo === "4") return "ERROR";
  return "EN PROCESO";
};

const mapApiToRow = (x: ApiRow): LayoutCargaMasivaRow => ({
  EstatusNombre: x.estatusNombre ??  "", // "EN PROCESO" | "GENERADA" | "DENEGADA"
  SolicitudServicioMensaje: x.solicitudServicioMensaje ?? "",
  SolicitudServicioId: x.solicitudServicioId ?? 0,
  Estatus: x.estatus ?? "",
  NombreRemitente: x.nombreRemitente ?? "",
  CodigoPostalRemitente: x.codigoPostalRemitente ?? "",
  CalleRemitente: x.calleRemitente ?? "",
  NoExteriorRemitente: x.noExteriorRemitente ?? "",
  NumeroGuia: x.numeroGuia??"",
  ColoniaRemitente: x.coloniaRemitente ?? "",
  TipoPersonaRemitente: x.tipoPersonaRemitente ?? "",
  RfcDistribuidorOrigen: x.rfcDistribuidorOrigen ?? "",
  TelefonoPersonaRemitente: x.telefonoPersonaRemitente ?? "",
  // Mantén el string tal cual (dd/MM/yyyy) para no romper formato
  FechaRecoleccion: x.fechaRecoleccion ?? "",
  NombreDestinatario: x.nombreDestinatario ?? "",
  CodigoPostalDestinatario: x.codigoPostalDestinatario ?? "",
  CalleDestinatario: x.calleDestinatario ?? "",
  NoExteriorDestinatario: x.noExteriorDestinatario ?? "",
  ColoniaDestinatario: x.coloniaDestinatario ?? "",
  TipoPersonaDestinatario: x.tipoPersonaDestinatario ?? "",
  RfcDistribuidorDestinatario: x.rfcDistribuidorDestinatario ?? "",
  ContactoDestinatario: x.contactoDestinatario ?? "",
  TelefonoDestinatario: x.telefonoDestinatario ?? "",
  DescripcionMercancia: x.descripcionMercancia ?? "",
  Observaciones: x.observaciones ?? "",
  DetalleReferencias: x.detalleReferencias ?? "",
  DetalleMercancia: x.detalleMercancia ?? "",
  ImpresionDocumento: x.impresionDocumento ?? "",
  ImpresionEtiqueta: x.impresionEtiqueta ?? "",
});


// Helper: solo seleccionables si estatus nombre es "Generada"
const isRowGenerada = (row?: LayoutCargaMasivaRow) => {
  const v = (row?.EstatusNombre ?? row?.Estatus ?? "")
    .toString()
    .trim()
    .toLowerCase();
  return v === "generada";
};



// seleccionar/deseleccionar una fila
const handleRowCheckbox = (globalIdx: number) => {
  setSelected(prev => {
    //Manténer la selección confinada a los visibles
    const onlyVisible = prev.filter(i => visibleIdx.includes(i));

    const i = onlyVisible.indexOf(globalIdx);
    if (i === -1) return [...onlyVisible, globalIdx]; // agrega
    const copy = onlyVisible.slice();
    copy.splice(i, 1); // quita
    return copy;
  });
};


// índices globales visibles en la página actual
const pageStart = page * rowsPerPage;
const visibleIdx = rows
  .slice(pageStart, pageStart + rowsPerPage)
  .map((_, i) => pageStart + i);
  
// Solo seleccionar las que dicen GENERADA:
const visibleSelectableIdx = visibleIdx.filter((i) => isRowGenerada(rows[i]));

// estado del checkbox maestro
const selectedInPage = visibleSelectableIdx.filter(i => selected.includes(i)).length;
const allChecked = visibleSelectableIdx.length > 0 && selectedInPage === visibleSelectableIdx.length;
const someChecked = selectedInPage > 0 && selectedInPage < visibleSelectableIdx.length;

// Errores de validación del backend (para mostrar en UI)
const [processErrors, setProcessErrors] = React.useState<BackendValidationError[]>([]);
const [openErrors, setOpenErrors] = React.useState(false);
// Grid events
const handleChangePage = (_: unknown, newPage: number) =>{
  setPage(newPage);
  setSelected([]);
};
const handleChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
    setSelected([]);
};
// Grid B (procesados)
const [processedRows, setProcessedRows] = useState<ProcesadoRow[]>([]);
// Control de vista: false = Grid A (con checks), true = Grid B (procesados)
const [showProcessedGrid, setShowProcessedGrid] = useState(false);
// ID de integración para el segundo paso
const [integracionId, setIntegracionId] = useState<string | null>(null);
// Credenciales para el endpoint solicitud-creacion-masiva
const [canProcess, setCanProcess] = useState(false);

const [usuarioLogueado, setUsuarioLogueado] = useState<string>(() => {
  return localStorage.getItem("usuario_nombre") ?? "";
});
const [usuarioLogueadoCuenta, setUsuarioLogueadoCuenta] = useState<string>(() => {
  return localStorage.getItem("clienteId") ?? "";
});

const usuarioQS = useMemo(
  () => encodeURIComponent(usuarioLogueado.trim()),
  [usuarioLogueado]
);
const cuentaQS = useMemo(
  () => encodeURIComponent(usuarioLogueadoCuenta.trim()),
  [usuarioLogueadoCuenta]
);

// Guías seleccionadas (solo filas con NúmeroGuia > 0)
const selectedGuias = useMemo<string[]>(() => {
  const guias = selected
    .map(i => rows[i]?.NumeroGuia)
    .filter((x): x is string => typeof x === "string" && x.trim() !== "" && Number(x) > 0)
    .map(g => g.trim());
  return Array.from(new Set(guias)); // únicos por seguridad
}, [selected, rows]);


// Modal Reimpresión
const [openReimp, setOpenReimp] = useState(false);
const handleOpenReimp = () => setOpenReimp(true);
const handleCloseReimp = () => setOpenReimp(false);
const toYMD = (d: Date | null) => {
  if (!d) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
  // Efects
  useEffect(() => {
      console.log(usuarioLogueado+"--"+usuarioLogueadoCuenta);
    // Carga catálogo de sucursales (preparado para BD)
    //ya cargas sucursales para Redux; en memoria
    (async () => {
      try {
        const res = await apiSource.obtenerAsync<any[]>("sucursal/many");
        setSucursales(
          (res || []).map((x) => ({ id: x.id ?? x.sucursalID ?? x.value, nombre: x.nombre ?? x.label }))
        );
      } catch {
        // opcional
      }
    })();
  }, [usuarioLogueado, usuarioLogueadoCuenta]);

  // ======= Acciones Botonera =======
  const handleBuscar = async () => {
    setShowProcessedGrid(false);
    setIntegracionId(null);
    setPage(0);
    try {
      setLoading(true);
      //cambia a Grid A
      setShowProcessedGrid(false);
      setPage(0);

    // Objeto base obligatorio
    const params: any = {
      usuario: usuarioLogueado,
      aplicativo: 2,
      clienteId: usuarioLogueadoCuenta
    };

    // Agrega dinámicamente solo si hay valor
    if (fecha) params.fechaProcesamiento = toYMD(fecha);
    if (estatus && estatus !== 0) params.estatus = estatus;
    if (remitente && remitente.trim() !== "") params.remitenteNombre = remitente.trim();
    if (sucursalOrigen) params.sucursalRemitenteId = sucursalOrigen;
    if (sucursalDestino) params.sucursalDestinatarioId = sucursalDestino;
    if (impresionDocumento) params.impresionDocumento = impresionDocumento;
    if (impresionEtiquetas) params.impresionEtiqueta = impresionEtiquetas;

      // baseURL al APIM, basta la ruta relativa:
      const resp = await apiSource.postAsync<ApiResponse>(
        "/integracion/obtener-generacion-masiva",
        params
      );
      const data = Array.isArray(resp?.response) ? resp.response : [];
      const mapped = data.map(mapApiToRow);

      setRows(mapped);
      setSelected([]); // limpia selección si usas checkboxes
      setPage(0);      // regresa a la primera página

      if (!resp?.success) {
        enqueueSnackbar("La API respondió sin éxito.", { variant: "warning" });
      }
    } catch(e) {
      enqueueSnackbar("No fue posible consultar los registros.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleCargarClick = () => {
      //resetear el value para que onChange dispare
      if (inputFileRef.current) {
        inputFileRef.current.value = ""; // fuerza nuevo cambio aunque sea el mismo nombre
      }
      // Limpia errores previos para permitir reintentar
      setProcessErrors([]);
      // Abre el selector de archivo
      inputFileRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIntegracionId(null);
    const file = e.target.files?.[0] ?? null;
    setSelectedFile(file);

    const ok = file ? isValidExtension(file.name) : false;
    setFileOk(ok);

    // limpiar errores previos para reactivar el flujo
    setProcessErrors([]);

    if (!ok && file) {
      enqueueSnackbar("Formato inválido. Solo se acepta Excel (.xls, .xlsx) o CSV.", { variant: "warning" });
      return;
    }

    //si es válido, procesar inmediatamente
    if (ok && file) {
      void handleProcesar(file);
    }
  };

  const handleProcesar = async (fileParam?: File) => {
    const file = fileParam ?? selectedFile;

    if (!file || !isValidExtension(file.name)) {
      enqueueSnackbar("Selecciona un archivo válido (.xls, .xlsx o .csv) antes de procesar.", { variant: "warning" });
      return;
    }

    try {
      if (showLoading) return; // evita dobles clics/doble envío
      setLoading(true);

      const form = new FormData();
      form.append("file", file);

      const url =
        "/integracion/integracion" +
        `?aplicativo=${encodeURIComponent(2)}` +
        `&usuario=${usuarioQS}` +
        `&cuenta=${cuentaQS}`;

      const result = await apiSource.postAsync<ProcessApiResponse>(url, form);

      const errores = result?.response?.errores ?? [];

      const procesados = Array.isArray(result?.response?.registrosProcesados)
        ? (result!.response!.registrosProcesados as unknown as ProcesadoRow[])
        : [];
      setIntegracionId(result?.response?.integracionId ?? null);

      // 1) Siempre que haya “registrosProcesados”, pinta el Grid B
      setProcessedRows(procesados);
      setShowProcessedGrid(true);
      setPage(0);

      if (Array.isArray(errores) && errores.length > 0) {
        setProcessErrors(errores);
        enqueueSnackbar(`Se encontraron ${errores.length} error(es) de validación en el archivo.`, { variant: "warning" });
        // no limpiamos el archivo; queda bloqueado hasta cargar otro
        return;
      }

      if (result?.success === true) {
        setCanProcess(true);
        enqueueSnackbar("Archivo integrado, puede Procesar su archivo éxitosamente.", { variant: "success" });
        setSelectedFile(null);
        setFileOk(false);
        return;
      }
      setCanProcess(false);
      enqueueSnackbar(result?.message || "El servidor no pudo procesar el layout.", { variant: "error" });
    } catch (e) {
      setCanProcess(false);
      enqueueSnackbar("Error al procesar el layout.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleDescargarLayout = () => {
    try {
      const url = `${process.env.PUBLIC_URL}/templates/layoutcargamasiva_postman_externo_Layout.xlsx`;
      const link = document.createElement("a");
      link.href = url;
      link.download = "Layout_Carga_Masiva.xlsx"; // nombre que tendrá el archivo al descargarse
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      enqueueSnackbar("No se pudo descargar la plantilla local.", { variant: "error" });
    }
  };

  const handleProcesarCrearSS = async () => {

    if (!integracionId) {
      enqueueSnackbar("No hay integración válida para procesar solicitudes.", { variant: "warning" });
      return;
    }

    try {
      if (showLoading) return;
      setLoading(true);

      const url = "/integracion/solicitud-creacion-masiva";
      const clienteId = usuarioLogueadoCuenta;
      const payload = {
        integracionId,
        clienteId,
      };
      const resp = await apiSource.postAsync<any>(url, payload);

      if (resp?.success === true) {
        enqueueSnackbar(resp?.message || "Se procesaron las solicitudes con éxito.", { variant: "success" });
        await handleBuscar();
        setCanProcess(false);
        return;
      }

      // Si success no es true, intenta mostrar el mensaje de backend
      enqueueSnackbar(resp?.message || "No fue posible procesar las solicitudes.", { variant: "error" });
    } catch (e) {
      enqueueSnackbar("Error al solicitar la creación masiva.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };


const handleSelectAllCurrentPage = (e: React.ChangeEvent<HTMLInputElement>) => {
  if (e.target.checked) {
    // marca SOLO las GENERADA visibles
    setSelected(visibleSelectableIdx);
  } else {
    // desmarca SOLO las GENERADA visibles
    setSelected(prev => prev.filter(i => !visibleSelectableIdx.includes(i)));
  }
};

  // IDs seleccionados listos para enviar al backend
const selectedIds = useMemo<number[]>(() => {
  // Tomamos los índices globales seleccionados y mapeamos a SolicitudServicioId
  const ids = selected
    .map((i) => rows[i]?.SolicitudServicioId)
    .filter((x): x is number => typeof x === "number" && x > 0);
  return Array.from(new Set(ids)); // únicos por seguridad
}, [selected, rows]);

// Endpoint helpers (ajusta rutas según tu backend)
const postIds = async (url: string, ids: number[]) => {
  return apiSource.postAsync<any>(url, ids);
};
const postGuias = async (url: string, guias: string[]) => {
  return apiSource.postAsync<IResultApi>(url, guias);
};

//Por si el endpoint recibe el arreglo crudo:
//const postIds = (url: string, ids: number[]) => apiSource.postAsync<IResultApi>(url, ids);
const handleReimprimirEtiquetas = async () => {
  if (selectedGuias.length === 0) {
    enqueueSnackbar("Selecciona al menos un registro con Número de Guía válido.", { variant: "warning" });
    return;
  }
  try {
    setLoading(true);
    // Ajusta la ruta a tu endpoint real:
    const response = await postGuias("/solicitud-servicio/solicitud-servicio-pdf-label-masiva", selectedGuias);
    const blob = b64toBlob(response, 'application/pdf');
       const blobUrl = URL.createObjectURL(blob);
       const link = document.createElement('a');
       const uuid = generateGuid().substring(0,8);
       link.href = blobUrl;
       link.download = uuid + ".pdf";
       link.click();

       await actualizarEstatusImpresion(2);
  } catch {
    enqueueSnackbar("Error al reimprimir etiquetas.", { variant: "error" });
  } finally {
    setLoading(false);
  }
};

const actualizarEstatusImpresion = async (tipoImpresion: number) => {
    const params = {
      solicitudServicioIds: selectedIds,
      tipoImpresion: tipoImpresion
    };

    const resp = await apiSource.postAsync<ApiResponse>(
      "/integracion/actualizar-estatus-impresion",
      params
    );
};

const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}


const handleReimprimirSolicitudMasiva = async () => {
  if (selectedIds.length === 0) {
    enqueueSnackbar("Selecciona al menos un registro (GENERADA).", { variant: "warning" });
    return;
  }
  try {
    setLoading(true);
    // Ajusta la ruta a la real de tu API -> botones preparados para ISRA:
    const response = await postIds("/solicitud-servicio/solicitud-servicio-pdf-masiva/1", selectedIds);
       setLoading(false);
       const blob = b64toBlob(response, 'application/pdf');
       const blobUrl = URL.createObjectURL(blob);
       const link = document.createElement('a');
       const uuid = generateGuid().substring(0,8);
       link.href = blobUrl;
       link.download = uuid + ".pdf";
       link.click();

       await actualizarEstatusImpresion(1);
  } catch {
    enqueueSnackbar("Error al reimprimir solicitudes.", { variant: "error" });
  } finally {
    setLoading(false);
  }
};

useEffect(() => { setSelected([]); }, [page, rowsPerPage]);

  return (
    <>
        {showLoading &&
            /*Procesando */
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }

      {/* Botonera superior (derecha) - mismo patrón que Cotizaciones :contentReference[oaicite:6]{index=6} */}
        <Box className={classes.topBar}>
        <input
            type="file"
            ref={inputFileRef}
            accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            style={{ display: "none" }}
            onChange={handleFileChange}
        />

       <Button variant="contained" color="primary"
            startIcon={<Search />}
            onClick={handleBuscar}
        >
            Buscar
        </Button>

        <Button variant="contained" color="primary"
            startIcon={<TableChart />}
            onClick={handleCargarClick}
        >
            Cargar Layout
        </Button>

        <Button variant="contained" color="primary"
            startIcon={<CloudUpload />}
            disabled={!canProcess}
            onClick={handleProcesarCrearSS}
        >
            Procesar
        </Button>

        <Button variant="contained" color="primary"
            startIcon={<CloudDownload />}
            onClick={handleDescargarLayout}
        >
            Descargar Layout
        </Button>
        </Box>

      {/* Filtros (izquierda bajo botón) */}
      <Box className={classes.filters}>
        <Grid container alignItems="center" spacing={2}>

          <Grid item>
            <Button variant="contained" color="primary"
              startIcon={<Print />}
              onClick={handleOpenReimp}
              disabled={selectedIds.length === 0} // opcional: habilítalo solo con selección
            >
              Reimprimir
            </Button>
          </Grid>

          <Grid item >
              <InputLabel id="estatus-label">Fecha</InputLabel>
          </Grid>
          <Grid item xs={2}>
            <DatePicker
              oneTap
                        format="MM-dd-yyyy" 
                        className="almex-datepicker"
              value={fecha ?? undefined}
              onChange={(d) => setFecha(d ?? null)}
              placeholder="Fecha de Registro"
            />
          </Grid>

          <Grid item xs={2}>
            <FormControl variant="outlined" className={classes.filterField}>
            <InputLabel id="estatus-label">Estatus</InputLabel>
            <Select
                labelId="estatus-label"
                label="Estatus"
                value={estatus}
                onChange={(e) => setEstatus(Number(e.target.value))}
            >
                <MenuItem value="0">--- SELECCIONE ---</MenuItem>
                <MenuItem value="2">EN PROCESO</MenuItem>
                <MenuItem value="3">GENERADA</MenuItem>
                <MenuItem value="4">DENEGADA</MenuItem>
            </Select>
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <TextField
              label="Nombre Remitente"
              variant="outlined"
              className={classes.filterField}
              value={remitente}
              onChange={(e) => setRemitente(e.target.value)}
            />
          </Grid>

          <Grid item xs={2}>
            <FormControl variant="outlined" className={classes.filterField}>
              <InputLabel id="suc-origen-label">Sucursal Origen</InputLabel>
              <Select
                labelId="suc-origen-label"
                label="Sucursal Origen" 
                value={sucursalOrigen}
                onChange={(e) => setSucursalOrigen(e.target.value as number | "")}
              >
                <MenuItem value="">— Seleccione —</MenuItem>
                {sucursales.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={2}>
            <FormControl variant="outlined" className={classes.filterField}>
              <InputLabel id="suc-destino-label">Sucursal Destino</InputLabel>
              <Select
                labelId="suc-destino-label"
                label="Sucursal Destino" 
                value={sucursalDestino}
                onChange={(e) => setSucursalDestino(e.target.value as number | "")}
              >
                <MenuItem value="">— Seleccione —</MenuItem>
                {sucursales.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.nombre}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

 <Box className={classes.filters}>
        <Grid container alignItems="center" spacing={2}>

          <Grid item xs={2} style={{marginLeft:'215px'}}>
            <FormControl variant="outlined" className={classes.filterField}>
            <InputLabel id="impresionDocumento-label">Documento SS</InputLabel>
            <Select
                labelId="impresionDocumento-label"
                label="Documento SS"
                value={impresionDocumento}
                onChange={(e) => setImpresionDocumento(Number(e.target.value))}
            >
                <MenuItem value="">--- SELECCIONE ---</MenuItem>
                <MenuItem value="2">Sin Imprimir</MenuItem>
                <MenuItem value="1">Impresas</MenuItem>
            </Select>
            </FormControl>
          </Grid>

           <Grid item xs={2}>
            <FormControl variant="outlined" className={classes.filterField}>
            <InputLabel id="impresionEtiqueta-label">Etiquetas</InputLabel>
            <Select
                labelId="impresionEtiqueta-label"
                label="Etiquetas"
                value={impresionEtiquetas}
                onChange={(e) => setImpresionEtiquetas(Number(e.target.value))}
            >
                <MenuItem value="">--- SELECCIONE ---</MenuItem>
                <MenuItem value="2">Sin Imprimir</MenuItem>
                <MenuItem value="1">Impresas</MenuItem>
            </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Box>

      {/* Grid de resultados con paginación/ordenamiento como tu estándar :contentReference[oaicite:7]{index=7} */}
{showProcessedGrid ? (
  <TableContainer component={Paper} className={classes.tableWrap}>
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell align="center"><b>Estatus</b></TableCell>
          <TableCell ><b>Comentario     </b></TableCell>
          <TableCell align="center"><b>NombreRemitente</b></TableCell>
          <TableCell align="center"><b>CodigoPostalRemitente</b></TableCell>
          <TableCell align="center"><b>CalleRemitente</b></TableCell>
          <TableCell align="center"><b>NoExteriorRemitente</b></TableCell>
          <TableCell align="center"><b>ColoniaRemitente</b></TableCell>
          <TableCell align="center"><b>TipoPersonaRemitente</b></TableCell>
          <TableCell align="center"><b>RfcDistribuidorOrigen</b></TableCell>
          <TableCell align="center"><b>TelefonoPersonaRemitente</b></TableCell>
          <TableCell align="center"><b>FechaRecoleccion</b></TableCell>
          <TableCell align="center"><b>NombreDestinatario</b></TableCell>
          <TableCell align="center"><b>CodigoPostalDestinatario</b></TableCell>
          <TableCell align="center"><b>CalleDestinatario</b></TableCell>
          <TableCell align="center"><b>NoExteriorDestinatario</b></TableCell>
          <TableCell align="center"><b>ColoniaDestinatario</b></TableCell>
          <TableCell align="center"><b>TipoPersonaDestinatario</b></TableCell>
          <TableCell align="center"><b>RfcDistribuidorDestinatario</b></TableCell>
          <TableCell align="center"><b>ContactoDestinatario</b></TableCell>
          <TableCell align="center"><b>TelefonoDestinatario</b></TableCell>
          <TableCell align="center"><b>DescripcionMercancia</b></TableCell>
          <TableCell align="center"><b>Observaciones</b></TableCell>
          <TableCell align="center"><b>DetalleReferencias</b></TableCell>
          <TableCell align="center"><b>DetalleMercancia</b></TableCell>


        </TableRow>
      </TableHead>
      <TableBody>
        {processedRows
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((r, idx) => (
                <TableRow
                  key={idx}
                  hover
                  style={{
                    backgroundColor:
                      r.estatusNombre?.toLowerCase() === "error" ? "#ffe5e5" : "inherit", // fondo rojo claro
                    color: r.estatusNombre?.toLowerCase() === "error" ? "#b00000" : "inherit", // texto rojo oscuro
                    fontWeight: r.estatusNombre?.toLowerCase() === "error" ? 600 : 400,
                  }}
                >
              <TableCell align="center">{r.estatusNombre}</TableCell>
              <TableCell align="center">{r.solicitudServicioMensaje ?? ""}</TableCell>
              <TableCell align="center">{r.nombreRemitente}</TableCell>
              <TableCell align="center">{r.codigoPostalRemitente}</TableCell>
              <TableCell align="center">{r.calleRemitente}</TableCell>
              <TableCell align="center">{r.noExteriorRemitente}</TableCell>
              <TableCell align="center">{r.coloniaRemitente}</TableCell>
              <TableCell align="center">{r.tipoPersonaRemitente}</TableCell>
              <TableCell align="center">{r.rfcDistribuidorOrigen}</TableCell>
              <TableCell align="center">{r.telefonoPersonaRemitente}</TableCell>
              <TableCell align="center">{r.fechaRecoleccion}</TableCell>
              <TableCell align="center">{r.nombreDestinatario}</TableCell>
              <TableCell align="center">{r.codigoPostalDestinatario}</TableCell>
              <TableCell align="center">{r.calleDestinatario}</TableCell>
              <TableCell align="center">{r.noExteriorDestinatario}</TableCell>
              <TableCell align="center">{r.coloniaDestinatario}</TableCell>
              <TableCell align="center">{r.tipoPersonaDestinatario}</TableCell>
              <TableCell align="center">{r.rfcDistribuidorDestinatario}</TableCell>
              <TableCell align="center">{r.contactoDestinatario}</TableCell>
              <TableCell align="center">{r.telefonoDestinatario}</TableCell>
              <TableCell align="center">{r.descripcionMercancia}</TableCell>
              <TableCell align="center">{r.observaciones}</TableCell> 
              <TableCell align="center">{r.detalleReferencias}</TableCell>
              <TableCell align="center">{r.detalleMercancia}</TableCell>

            </TableRow>
          ))}
        {processedRows.length === 0 && (
          <TableRow>
            <TableCell colSpan={24} align="center">
              Sin resultados procesados.
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>

    <TablePagination
      component="div"
      count={processedRows.length}
      page={page}
      onChangePage={handleChangePage}
      rowsPerPage={rowsPerPage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
      rowsPerPageOptions={[20]}      // o [10,20,50] si quieres opciones
      labelRowsPerPage="Filas por página"
    />
  </TableContainer>
) : (
  // Grid A (con checks)
  <>
      <TableContainer component={Paper} className={classes.tableWrap}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
                <TableCell padding="checkbox" align="center">
                <Checkbox
                  indeterminate={someChecked}
                  checked={allChecked}
                  onChange={handleSelectAllCurrentPage}
                  color="primary"
                  inputProps={{ "aria-label": "Seleccionar todos (página actual)" }}
                />
                </TableCell>
              <TableCell align="center"><b>Estatus</b></TableCell>
               <TableCell align="center"><b><InputLabel style={{
                                              width: "110px",
                                              fontSize: "0.875rem",
                                              fontWeight: "bold",
                                              color: "#202020",
                                            }}>Documento SS</InputLabel></b></TableCell>
              <TableCell align="center"><b><InputLabel style={{
                                              width: "110px",
                                              fontSize: "0.875rem",
                                              fontWeight: "bold",
                                              color: "#202020",
                                            }}>Etiquetas</InputLabel></b></TableCell>
              <TableCell align="center"><b>SolicitudServicioMensaje</b></TableCell>
              <TableCell align="center"style={{ display: "none" }}><b>SolicitudServicioId</b></TableCell>
              <TableCell align="center"><b>NombreRemitente</b></TableCell>
              <TableCell align="center"><b>CodigoPostalRemitente</b></TableCell>
              <TableCell align="center"><b>CalleRemitente</b></TableCell>
              <TableCell align="center"><b>NoExteriorRemitente</b></TableCell>

              <TableCell align="right"><b>ColoniaRemitente</b></TableCell>
              <TableCell align="right"><b>TipoPersonaRemitente</b></TableCell>
              <TableCell align="right"><b>RfcDistribuidorOrigen</b></TableCell>
              <TableCell align="right"><b>TelefonoPersonaRemitente</b></TableCell>
              <TableCell align="right"><b>FechaRecoleccion</b></TableCell>
              <TableCell align="right"><b>NombreDestinatario</b></TableCell>
              <TableCell align="right"><b>CodigoPostalDestinatario</b></TableCell>
              <TableCell align="right"><b>CalleDestinatario</b></TableCell>
              <TableCell align="right"><b>NoExteriorDestinatario</b></TableCell>
              <TableCell align="right"><b>ColoniaDestinatario</b></TableCell>
              <TableCell align="right"><b>TipoPersonaDestinatario</b></TableCell>
              <TableCell align="right"><b>RfcDistribuidorDestinatario</b></TableCell>
              <TableCell align="right"><b>ContactoDestinatario</b></TableCell>
              <TableCell align="right"><b>TelefonoDestinatario</b></TableCell>
              <TableCell align="right"><b>DescripcionMercancia</b></TableCell>
              <TableCell align="right"><b>Observaciones</b></TableCell>
              <TableCell align="right"><b>DetalleReferencias</b></TableCell>
              <TableCell align="center"><b>DetalleMercancia</b></TableCell>
              <TableCell align="right"><b>NumeroGuia</b></TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {rows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((r, idx) => {
              const gIdx = pageStart + idx;           // índice global visible
              const checked = selected.includes(gIdx); // ya filtrado por página
      return (
        <TableRow key={gIdx} hover selected={checked}>
          <TableCell padding="checkbox" align="center">
          <Checkbox
            color="primary"
            checked={selected.includes(gIdx)}
            onChange={() => handleRowCheckbox(gIdx)}
            disabled={!isRowGenerada(r)}
          />
          </TableCell>
                    <TableCell align="center">{r.EstatusNombre}</TableCell>
                    <TableCell align="center">{r.ImpresionDocumento}</TableCell>
                    <TableCell align="center">{r.ImpresionEtiqueta}</TableCell>
                    <TableCell align="center">{r.NumeroGuia && Number(r.NumeroGuia) > 0 ? r.NumeroGuia : r.SolicitudServicioMensaje}</TableCell>
                    <TableCell align="center" style={{ display: "none" }}>{r.SolicitudServicioId}</TableCell>
                    <TableCell align="center">{r.NombreRemitente}</TableCell>
                    <TableCell align="center">{r.CodigoPostalRemitente}</TableCell>
                    <TableCell align="center">{r.CalleRemitente}</TableCell>
                    <TableCell align="center">{r.NoExteriorRemitente}</TableCell>

                    <TableCell align="right">{r.ColoniaRemitente}</TableCell>
                    <TableCell align="right">{r.TipoPersonaRemitente}</TableCell>
                    <TableCell align="right">{r.RfcDistribuidorOrigen}</TableCell>
                    <TableCell align="right">{r.TelefonoPersonaRemitente}</TableCell>
                    <TableCell align="right">{r.FechaRecoleccion}</TableCell>
                    <TableCell align="right">{r.NombreDestinatario}</TableCell>
                    <TableCell align="right">{r.CodigoPostalDestinatario}</TableCell>
                    <TableCell align="right">{r.CalleDestinatario}</TableCell>
                    <TableCell align="right">{r.NoExteriorDestinatario}</TableCell>
                    <TableCell align="right">{r.ColoniaDestinatario}</TableCell>
                    <TableCell align="right">{r.TipoPersonaDestinatario}</TableCell>
                    <TableCell align="right">{r.RfcDistribuidorDestinatario}</TableCell>
                    <TableCell align="right">{r.ContactoDestinatario}</TableCell>
                    <TableCell align="right">{r.TelefonoDestinatario}</TableCell>
                    <TableCell align="right">{r.DescripcionMercancia}</TableCell>
                    <TableCell align="right">{r.Observaciones}</TableCell>
                    <TableCell align="right">{r.DetalleReferencias}</TableCell>
                    <TableCell align="right">{r.DetalleMercancia}</TableCell>
                    <TableCell align="right">{r.NumeroGuia}</TableCell>
                </TableRow>
              );
            })}
            {rows.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  Sin resultados.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
            component="div"
            count={rows.length}
            page={page}
            onChangePage={handleChangePage}
            rowsPerPage={rowsPerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            rowsPerPageOptions={[10,20]}           // fijo en 20; usa [20, 50, 100] si quieres opciones
            labelRowsPerPage="Filas por página"
       />
  </>
)}

      <Dialog open={openReimp} onClose={handleCloseReimp} fullWidth maxWidth="sm">
        <DialogTitle>Reimpresión</DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" gutterBottom>
            Registros seleccionados: <b>{selectedIds.length}</b>
          </Typography>
          <Typography variant="caption" color="textSecondary">
            Solo se consideran filas con estatus <b>GENERADA</b>.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary"
            onClick={handleReimprimirSolicitudMasiva}
            startIcon={<Print />}
            disabled={selectedIds.length === 0}
          >
            SOLICITUD
          </Button>
          <Button variant="contained" color="primary"
            onClick={handleReimprimirEtiquetas}
            startIcon={<Print />}
            disabled={selectedIds.length === 0}
          >
            IMPRESORA ETIQUETADORA
          </Button>
          <Button onClick={handleCloseReimp} color="default" variant="outlined">
            Salir
          </Button>
        </DialogActions>
      </Dialog>



    </>
  );
};

export default CargaMasivaLista;
